import { Button, TextField } from "@mui/material";
import React, { useMemo, useState } from "react";
import DataTable from "react-data-table-component";

const FilterComponent = ({ filterText, onFilter, onClear }) => (
  <>
    <TextField
      // className={classes.outlineInputBorder}
      id="search"
      type="text"
      placeholder="Filter By Name"
      aria-label="Search Input"
      value={filterText}
      onChange={onFilter}
    />
    <Button type="button" onClick={onClear}>
      X
    </Button>
  </>
);

const Index = (props) => {
  const {
    columns,
    data,
    selectableRows,
    subHeaderComponent,
    pagination,
    conditionalRowStyles,
    customStyles,
    onChangeRowsPerPage,
    direction,
    striped,
    onRowClicked,
    selectableRowSelected,
    onSelectedRowsChange,
    clearRow,
    progressPending,
    progressComponent,
    expandableRows,
    expandableRowsComponent,
    onRowDoubleClicked,
    expandableRowsComponentProps,
    expandableRowExpanded,
  } = props;

  const [filterText, setFilterText] = useState("");

  return (
    <DataTable
      columns={columns}
      data={data}
      selectableRows={selectableRows}
      pagination={pagination}
      clearSelectedRows={clearRow}
      onChangeRowsPerPage={onChangeRowsPerPage}
      conditionalRowStyles={conditionalRowStyles}
      customStyles={customStyles}
      direction={direction}
      striped={striped}
      progressComponent={progressComponent}
      progressPending={progressPending}
      onSelectedRowsChange={onSelectedRowsChange}
      onRowClicked={onRowClicked}
      selectableRowSelected={selectableRowSelected}
      expandableRows={expandableRows}
      expandableRowsComponent={expandableRowsComponent}
      onRowDoubleClicked={onRowDoubleClicked}
      expandableRowsComponentProps={expandableRowsComponentProps}
      {...props}
    />
  );
};

export default Index;
